import { supabase } from '@/integrations/supabase/client';

export interface ShortItem {
  id: string;
  title: string;
  thumbnailUrl: string;
  publishedAt?: string;
  durationSeconds?: number;
  viewCount?: string;
}

export interface FetchShortsOptions {
  channel?: string;
  channelId?: string; // Prefer passing a UC* channel ID to avoid expensive search
}

export async function fetchYouTubeShorts(maxResults = 12, options?: FetchShortsOptions): Promise<ShortItem[]> {
  const body: Record<string, any> = { maxResults };
  if (options?.channelId) body.channelId = options.channelId;
  else if (options?.channel) body.channel = options.channel;

  const { data, error } = await supabase.functions.invoke('youtube-shorts', {
    body,
  });
  if (error) {
    console.error('fetchYouTubeShorts error', error);
    return [];
  }
  return (data as ShortItem[]) || [];
}

export default { fetchYouTubeShorts };
